function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.41296 39.3026C9.68824 40.1375 16.9636 40.6971 20.6517 40.9448V34.1557C17.5324 33.9172 10.8351 33.4401 8.09189 32.7337C7.32123 32.541 6.77994 31.8346 6.77994 31.0089V20.4766H0V31.0089C0 34.9264 2.64225 38.3393 6.41296 39.3026Z",
  fill: "#5AD2FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6707 1.80699C35.0651 0.632656 28.3127 0.00878906 23.0374 0.00878906V6.78873C27.7531 6.78873 33.9183 7.3392 37.9826 8.38509C38.7533 8.57775 39.2946 9.29336 39.2946 10.1191V20.4954H46.0745V10.1007C46.0837 6.18321 43.4506 2.77031 39.6707 1.80699Z",
  fill: "#FABE00"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.047 0V6.77994C18.3313 6.77994 12.1661 7.33041 8.09262 8.36712C7.32196 8.56896 6.78067 9.27539 6.78067 10.1011V20.4774L0.000732422 13.6975V10.1011C0.000732422 6.1836 2.6338 2.77069 6.41369 1.80737C11.0193 0.623866 17.7717 0 23.047 0Z",
  fill: "#E62D32"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.743 39.4807C39.7464 39.4795 39.7497 39.4782 39.753 39.4767C43.2026 37.8803 46.0834 35.4858 46.0834 31.0086V27.2471L39.3034 20.4672V29.1833C39.2987 31.0916 39.1442 31.8865 37.3769 32.7612L20.6519 40.954V49L39.743 39.4807Z",
  fill: "#5082E6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.523 25.1285C17.7524 25.1285 19.5597 23.3211 19.5597 21.0917C19.5597 18.8623 17.7524 17.0549 15.523 17.0549C13.2935 17.0549 11.4862 18.8623 11.4862 21.0917C11.4862 23.3211 13.2935 25.1285 15.523 25.1285Z",
  fill: "#5082E6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9177 25.1285C33.1472 25.1285 34.9545 23.3211 34.9545 21.0917C34.9545 18.8623 33.1472 17.0549 30.9177 17.0549C28.6883 17.0549 26.881 18.8623 26.881 21.0917C26.881 23.3211 28.6883 25.1285 30.9177 25.1285Z",
  fill: "#5082E6"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.0fbce9ff.svg";
export { ForwardRef as ReactComponent };